<ng-container *ngIf="!quickAddToCart">
  <div
    tappable
    @animatedItem
    class="menu-item"
    [class.unavailable]="itemDetails.availability !== Availability.Available"
    data-cy="menu-item"
    (click)="onItemSelected()"
  >
    <div class="lazy-loading-image-container">
      <div #lazyLoadingImage [attr.data-src]="itemDetails.imageUrl" class="lazy-loading-image not-loaded animated-image">
        <div
          class="lazy-loading-image-content"
          [style.backgroundImage]="itemDetails.imageUrl ? 'url(' + itemDetails.imageUrl + ')' : null"
        ></div>
      </div>

      <div
        class="menu-item-notice"
        data-cy="notice-period-warning-message"
        *ngIf="itemDetails.availability === Availability.Available && itemDetails.noticePeriodWarningMessage"
      >
        <ion-icon src="/assets/custom-icons/b-clock.svg"></ion-icon>
        <span>{{ itemDetails.noticePeriodWarningMessage }}</span>
      </div>

      <div class="item-unavailability" *ngIf="itemDetails.availability !== Availability.Available">
        <span class="item-unavailability-text">{{ "UNAVAILABLE" | translate }}</span>
      </div>
    </div>

    <div class="menu-item-info">
      <div class="details">
        <ng-container *ngIf="itemDetails.badges && itemDetails.badges[0]; let itemFirstBadge">
          <div class="menu-item-badge" [style.color]="itemFirstBadge.foreColor" [style.backgroundColor]="itemFirstBadge.backColor">
            <ion-icon *ngIf="itemFirstBadge.iconUrl" class="menu-item-badge-icon" [src]="itemFirstBadge.iconUrl"></ion-icon>
            {{ itemFirstBadge.text }}
          </div>
        </ng-container>

        <div class="menu-item-name" data-cy="menu-item-name">{{ itemDetails.name }}</div>

        <div *ngIf="showVendorName && itemDetails.vendorName" class="menu-item-vendor-name">
          {{ "BY" | translate | lowercase }}
          <span tappable (click)="onVendorSelected($event)" class="menu-item-vendor-name-highlighted">{{ itemDetails.vendorName }}</span>
        </div>

        <div class="menu-item-price" *ngIf="itemDetails.availability === Availability.Available">
          <ng-container *ngIf="itemDetails.price">
            <span class="price">{{ itemDetails.price | localCurrency }}</span>
            <span class="retail" *ngIf="itemDetails.onSale">{{ itemDetails.retailPrice | localCurrency }}</span>
          </ng-container>

          <ng-container *ngIf="!itemDetails.price">
            <span class="price" *ngIf="!itemDetails.supportStartingPrice || !itemDetails.minimumCost">
              {{ "PRICE_ON_SELECTION" | translate }}
            </span>

            <ng-container *ngIf="itemDetails.supportStartingPrice && itemDetails.minimumCost">
              <span class="price">{{ "STARTING_FROM" | translate }} {{ itemDetails.minimumCost | localCurrency }}</span>
              <span class="retail min-cost" *ngIf="itemDetails.onSale">
                {{ "STARTING_FROM" | translate }} {{ itemDetails.retailMinimumCost | localCurrency }}
              </span>
            </ng-container>
          </ng-container>
        </div>

        <div
          class="menu-item-availability"
          *ngIf="itemDetails.availability !== Availability.Available"
          [style.color]="itemDetails.availabilityTextColor ? itemDetails.availabilityTextColor : '#e66363'"
        >
          {{ itemDetails.availabilityText }}
        </div>

        <div class="menu-item-description">
          {{ itemDetails.description }}
        </div>

        <div
          tappable
          class="check-availability-button"
          (click)="onCheckAvailability($event)"
          *ngIf="itemDetails.availability !== Availability.Available && itemDetails.supportsCheckNextAvailableDateTime"
        >
          {{ "CHECK_AVAILABILITY" | translate }}
        </div>
      </div>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="quickAddToCart">
  <div
    @animatedItem
    data-cy="menu-item"
    class="quick-add-to-cart-item"
    [class.not-available]="itemDetails.availability !== Availability.Available"
  >
    <div class="item-info" tappable (click)="onItemSelected()">
      <div [attr.data-src]="itemDetails.imageUrl" class="lazy-loading-image not-loaded animated-image">
        <div
          class="lazy-loading-image-content"
          [style.backgroundImage]="itemDetails.imageUrl ? 'url(' + itemDetails.imageUrl + ')' : null"
        ></div>
      </div>

      <div data-cy="menu-item-name" class="item-title">{{ itemDetails.name }}</div>
      <div class="item-description">{{ itemDetails.description }}</div>
    </div>

    <div
      class="item-discount"
      *ngIf="
        itemDetails.onSale && ((itemDetails.price && itemDetails.retailPrice) || (itemDetails.minimumCost && itemDetails.retailMinimumCost))
      "
    >
      <span *ngIf="itemDetails.price" class="item-discount-amount">
        {{ (itemDetails.price - itemDetails.retailPrice) / itemDetails.retailPrice | percent }}
      </span>
      <span *ngIf="!itemDetails.price" class="item-discount-amount">
        {{ (itemDetails.minimumCost - itemDetails.retailMinimumCost) / itemDetails.retailMinimumCost | percent }}
      </span>
    </div>

    <div class="item-cta">
      <ng-container *ngIf="itemDetails.availability === Availability.Available">
        <ion-button
          data-cy="menu-item-add-to-cart-button"
          class="custom-button"
          color="grey"
          (click)="onIncreaseItemQuantity($event)"
          *ngIf="!itemQuantity"
        >
          <span *ngIf="itemDetails.price">{{ itemDetails.price | localCurrency }}</span>

          <ng-container *ngIf="!itemDetails.price">
            <span class="price-on-selection" *ngIf="!itemDetails.supportStartingPrice || !itemDetails.minimumCost">
              {{ "PRICE_ON_SELECTION" | translate }}
            </span>

            <ng-container *ngIf="itemDetails.supportStartingPrice && itemDetails.minimumCost">
              <span class="price-on-selection">{{ "FROM" | translate }} {{ itemDetails.minimumCost | localCurrency }}</span>
            </ng-container>
          </ng-container>
        </ion-button>

        <ng-container *ngIf="itemQuantity">
          <ion-button
            color="grey"
            class="custom-button decrement"
            data-cy="menu-item-add-to-cart-decrement-button"
            (click)="onDecreaseItemQuantity($event)"
          >
            <ion-icon slot="icon-only" src="/assets/custom-icons/b-minus.svg"></ion-icon>
          </ion-button>

          <span class="quantity" data-cy="grocery-item-quantity">{{ itemQuantity }}</span>

          <ion-button
            color="grey"
            [disabled]="itemDetails.maxQuantity && itemDetails.maxQuantity === itemQuantity"
            class="custom-button increment"
            data-cy="menu-item-add-to-cart-increment-button"
            (click)="onIncreaseItemQuantity($event)"
          >
            <ion-icon slot="icon-only" src="/assets/custom-icons/b-plus.svg"></ion-icon>
          </ion-button>
        </ng-container>
      </ng-container>

      <ng-container *ngIf="itemDetails.availability !== Availability.Available">
        <ion-button disabled class="custom-button" color="grey">{{ "UNAVAILABLE" | translate }}</ion-button>
      </ng-container>
    </div>
  </div>
</ng-container>
